import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout/index.jsx";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useGetAllCampusesQuery } from "../../../../graphql/generated.tsx";
import Loader from "../../../../components/Loader.jsx";

const StudentData = () => {
  const [campus, setCampus] = useState([]);
  const { data, loading, error } = useGetAllCampusesQuery();
  const [Isload, setIsload] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsload(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (data) {
      setCampus(data.allCampus);
    }
  }, [data]);

  if (loading || Isload) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center h-screen">
          <Loader />
        </div>
      </AdminLayout>
    );
  }

  if (error) return <AdminLayout>Error: {error.message}</AdminLayout>;

  return (
    <AdminLayout>
      <div className="min-h-screen p-6 md:p-10 bg-gradient-to-br from-blue-50 to-purple-100">
        
        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-10">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="flex items-center gap-2 px-4 py-2 transition duration-200 bg-white border border-gray-300 shadow-sm rounded-xl hover:border-blue-500 hover:bg-blue-50"
            >
              <IoMdArrowRoundBack className="w-5 h-5 text-gray-600" />
              <span className="font-medium text-gray-700">Back</span>
            </button>
            <h1 className="ml-4 text-2xl font-bold text-gray-800">All Campuses</h1>
          </div>
        </div>

        {/* ✅ Centered Campus Cards */}
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
          {campus.map((campus) => (
            <a
              key={campus.id}
              href={`/admin/students/${campus.id}`}
              className="transition-transform duration-300 hover:scale-[1.02] group"
            >
              <div className="relative bg-white rounded-xl shadow-md min-h-[130px] flex items-center justify-center overflow-hidden transition-all duration-300">
                
                {/* ✅ Perfectly Centered Name */}
                <h5 className="text-xl font-semibold text-center text-gray-800 transition group-hover:text-blue-700">
                  {campus.name}
                </h5>

                {/* Gradient bottom border */}
                <div className="absolute bottom-0 left-0 w-full h-[4px] bg-gradient-to-r from-sky-700 via-sky-400 to-sky-200 rounded-b-xl" />
              </div>
            </a>
          ))}
        </div>

        {/* Empty state */}
        {campus.length === 0 && (
          <p className="mt-10 text-lg text-center text-gray-500">
            No campuses found.
          </p>
        )}
      </div>
    </AdminLayout>
  );
};

export default StudentData;
